import script from "./JoinSuccessPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinSuccessPopup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__